import { render, staticRenderFns } from "./BeneficiarySummary.vue?vue&type=template&id=c5ccb0ae&"
import script from "./BeneficiarySummary.vue?vue&type=script&lang=js&"
export * from "./BeneficiarySummary.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiarySummary.vue?vue&type=style&index=0&id=c5ccb0ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports